import { request } from '@umijs/max';

/** 导出任务类型 */
export const EXPORT_TASK_TYPE = {
  OrderList: 'OrderList',
  OrderBomComparison: 'OrderBomComparison',
  /** 批量校对订单（后台任务） */
  OrderCheck: 'OrderCheck',
} as const;

export type ExportTaskType =
  (typeof EXPORT_TASK_TYPE)[keyof typeof EXPORT_TASK_TYPE];

/** 导出任务状态 */
export const EXPORT_TASK_STATUS = {
  Queued: 0,
  Generating: 1,
  Completed: 2,
  Failed: 3,
  Downloaded: 4,
} as const;

export type ExportTaskItem = {
  id: number;
  status: number;
  fileName?: string | null;
  taskType?: string | null;
  [key: string]: any;
};

/**
 * 创建导出任务（大数据量后台导出）
 */
export async function createExportTask(
  params?: any,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>('/api/app/exporttask/createexporttask', {
    method: 'POST',
    data: params,
    ...(options || {}),
  });
}

/**
 * 查询当前用户的全部导出任务（不分页）
 */
export async function getMyExportTasks(options?: { [key: string]: any }) {
  return request<API.IServiceResult>('/api/app/exporttask/getmyexporttasks', {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 下载已生成的导出文件（成功后后端将状态置为已下载）
 */
export async function downloadExportFile(
  id: number,
  options?: { [key: string]: any },
) {
  return request<any>('/api/app/exporttask/downloadexportfile', {
    method: 'GET',
    params: { id },
    responseType: 'blob',
    getResponse: true,
    ...(options || {}),
  });
}

/**
 * 创建批量校对订单后台任务（勾选超过同步上限时）
 */
export async function createExportTaskBatchCheckOrder(
  ids: number[],
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/exporttask/createexporttask_batchcheckorder',
    {
      method: 'POST',
      data: ids,
      ...(options || {}),
    },
  );
}

/**
 * 获取批量校对订单任务提示（GET /api/app/exporttask/getexporttaskmessage?id=）
 * 提示文案在返回的 message / data 中；调用成功后后端通常将任务状态置为已下载
 */
export async function getExportTaskMessage(
  id: number,
  options?: { [key: string]: any },
) {
  return request<API.IServiceResult>(
    '/api/app/exporttask/getexporttaskmessage',
    {
      method: 'GET',
      params: { id },
      ...(options || {}),
    },
  );
}
